import PropTypes from 'prop-types';

import Typography from "@mui/material/Typography";

const MaterialNoData = ({ message }) => {
  return(
    <div style={{ textAlign: 'center', marginTop: '50px'}}>
      <Typography 
        variant="subtitle1" 
        color="text.secondary"
      >
        {message}
      </Typography>
    </div>
  );
};

MaterialNoData.propTypes = {
  message: PropTypes.string.isRequired,
};

export default MaterialNoData;